import React from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';
import { getTranslation } from '../translations';
import './ServiceHighlights.css';

function ServiceHighlights() {
  const { language } = useThemeLanguage();
  const t = (key) => getTranslation(language, 'landing', key);
  const isRtl = language === 'he' || language === 'ar';

  return (
    <section className="service-highlights" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="service-highlights-inner">
        <header className="service-highlights-header">
          <h2 className="service-highlights-title">{t('serviceHighlightsTitle')}</h2>
          <p className="service-highlights-subtitle">{t('serviceHighlightsSubtitle')}</p>
        </header>

        <ul className="service-highlights-points">
          <li>
            <strong>{t('servicePoint1Title')}</strong>
            <span>{t('servicePoint1Text')}</span>
          </li>
          <li>
            <strong>{t('servicePoint2Title')}</strong>
            <span>{t('servicePoint2Text')}</span>
          </li>
          <li>
            <strong>{t('servicePoint3Title')}</strong>
            <span>{t('servicePoint3Text')}</span>
          </li>
        </ul>

        <div className="service-highlights-stats">
          <div className="service-stat">
            <span className="service-stat-value">{t('statBroadcastHoursVal')}</span>
            <span className="service-stat-label">{t('statBroadcastHours')}</span>
          </div>
          <div className="service-stat">
            <span className="service-stat-value">{t('statViewingHoursVal')}</span>
            <span className="service-stat-label">{t('statViewingHours')}</span>
          </div>
          <div className="service-stat">
            <span className="service-stat-value">{t('statHomesVal')}</span>
            <span className="service-stat-label">{t('statHomes')}</span>
          </div>
        </div>
        <p className="service-highlights-footnote">{t('serviceStatsFootnote')}</p>
      </div>
    </section>
  );
}

export default ServiceHighlights;
